/* ───────────────────────── VERSA theme · vanilla JS ───────────────────────── */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- HERO: auto-cycling patch on a static cap ---------- */
  function initCustomizer() {
    var stage = $('[data-stage]');
    if (!stage) return;
    var patches = $$('[data-patch]', stage);
    if (!patches.length) return;

    var nowEl = $('[data-now]');
    var tagEl = $('[data-current-tag]');
    var blurbEl = $('[data-current-blurb]');
    var rail = $$('[data-rail-item]');
    var idx = 0;
    var timer = null;
    var resumeTimer = null;
    var CYCLE = 3600;

    function show(i, animateCaption) {
      idx = (i + patches.length) % patches.length;
      patches.forEach(function (p, k) { p.classList.toggle('on', k === idx); });
      rail.forEach(function (b, k) { b.classList.toggle('sel', k === idx); });
      var p = patches[idx];
      var color = p.getAttribute('data-color') || '#E5362B';
      if (nowEl) {
        nowEl.textContent = p.getAttribute('data-name') || '';
        nowEl.style.color = color;
        if (animateCaption) { nowEl.style.animation = 'none'; void nowEl.offsetWidth; nowEl.style.animation = ''; }
      }
      if (tagEl) {
        tagEl.textContent = p.getAttribute('data-tag') || '';
        tagEl.style.borderColor = color;
        tagEl.style.color = color;
      }
      if (blurbEl) blurbEl.textContent = p.getAttribute('data-blurb') || '';
    }

    function start() { stop(); timer = setInterval(function () { show(idx + 1, true); }, CYCLE); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function select(i) {
      show(i, true);
      stop();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, 9000); // resume the show after a beat
    }

    rail.forEach(function (b, k) {
      b.addEventListener('click', function () { select(k); });
      b.addEventListener('mouseenter', function () { select(k); });
    });

    show(0, false);
    start();

    // pause cycling while hovering the cap
    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  /* ---------- CART drawer (Shopify AJAX) ---------- */
  function initCart() {
    var drawer = $('[data-cart-drawer]');
    var scrim = $('[data-cart-scrim]');
    var body = $('[data-cart-body]');
    var totalEl = $('[data-cart-total]');
    if (!drawer) return;

    function open() { drawer.classList.add('on'); if (scrim) scrim.classList.add('on'); refresh(); }
    function close() { drawer.classList.remove('on'); if (scrim) scrim.classList.remove('on'); }

    function setCount(n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }

    function render(cart) {
      setCount(cart.item_count);
      if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
      if (!body) return;
      if (!cart.item_count) {
        body.innerHTML = '<p class="cart-empty mono">CART IS EMPTY.<br>GO BUILD SOMETHING.</p>';
        return;
      }
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image || (it.featured_image && it.featured_image.url) || '';
        return '<div class="cart-item">' +
          (img ? '<img src="' + img + '" alt="">' : '') +
          '<div class="ci-txt"><strong>' + it.product_title + '</strong>' +
          '<span class="mono">INCLUDES ALL 5 STYLES</span></div>' +
          '<div class="ci-right"><span class="ci-price">' + money(it.final_line_price, cart.currency) + '</span>' +
          '<button class="ci-rm" type="button" data-rm="' + it.key + '">Remove</button></div></div>';
      }).join('');
    }

    function refresh() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    // add to cart
    $$('[data-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        var btn = form.querySelector('button');
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        }).then(function (r) { return r.json(); })
          .then(function () { open(); })
          .catch(function () {})
          .then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
      });
    });

    // demo add (no product connected)
    $$('[data-demo-add]').forEach(function (b) {
      b.addEventListener('click', function () { open(); });
    });

    // remove line
    if (body) body.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rm]');
      if (!rm) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-rm'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    });

    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- PROMO: 10% off email signup ---------- */
  function initPromo() {
    var fab = $('[data-promo-open]');
    var card = $('[data-promo-card]');
    var scrim = $('[data-promo-scrim]');
    if (!fab || !card) return;
    var formWrap = $('[data-promo-form]');
    var success = $('[data-promo-success]');
    var form = $('.promo-form', card);
    var input = $('.promo-input', card);
    var err = $('[data-promo-err]');
    var KEY = 'versaPromo';

    function open() { card.classList.add('on'); if (scrim) scrim.classList.add('on'); }
    function close() { card.classList.remove('on'); if (scrim) scrim.classList.remove('on'); }
    function showSuccess() {
      if (formWrap) formWrap.setAttribute('hidden', '');
      if (success) success.removeAttribute('hidden');
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      try { fetch('/discount/VERSA15', { method: 'GET', credentials: 'same-origin' }); } catch (e) {}
      if (window.fbq) { try { fbq('track', 'Lead'); } catch (e) {} }
      var label = fab.querySelector('span:last-child');
      if (label) label.textContent = 'Your code: VERSA15';
    }

    // validate before letting the customer form submit (page will reload on success)
    if (form && input) {
      form.addEventListener('submit', function (e) {
        var v = (input.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) {
          e.preventDefault();
          if (err) { err.textContent = 'Enter a valid email'; err.removeAttribute('hidden'); }
          return;
        }
        try { localStorage.setItem(KEY, '1'); } catch (e2) {}
      });
      input.addEventListener('input', function () { if (err) err.setAttribute('hidden', ''); });
    }

    $$('[data-promo-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-promo-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);

    // returning subscriber: reflect code on the button
    var already = false;
    try { already = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (already) { var label = fab.querySelector('span:last-child'); if (label) label.textContent = 'Your code: VERSA15'; }

    // Shopify reloaded the page after a successful signup
    if ($('[data-promo-posted]')) { showSuccess(); open(); }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCustomizer();
    initCart();
    initPromo();
  });
})();
